import { render, staticRenderFns } from "./ActionBtns.vue?vue&type=template&id=6192d918&"
import script from "./ActionBtns.vue?vue&type=script&lang=js&"
export * from "./ActionBtns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports